module.exports = __webpack_public_path__ + "media/assets/images/icn-checkmark-d4edbf0e8f8d5cb754c902d62450851b.svg";